import { MergeFieldCategory, MergeFields, ObjectMergeFields } from '../types';

export const isObjectMergeFields = (
  mf: MergeFields[number]
): mf is ObjectMergeFields => {
  return mf && typeof mf === 'object' && 'fields' in mf;
};

export const isMergeFieldCategory = (
  mf: MergeFields[number]
): mf is MergeFieldCategory => {
  return mf && typeof mf === 'object' && 'items' in mf;
};

export const getMergeFieldRelationships = (
  mergeFields: MergeFields
): Set<string> => {
  const result = new Set<string>();

  for (const mf of mergeFields) {
    if (isObjectMergeFields(mf)) {
      for (const category of mf.fields) {
        for (const item of category.items) {
          result.add(item.relationship);
        }
      }
      continue;
    }

    if (isMergeFieldCategory(mf)) {
      for (const item of mf.items) {
        result.add(item.relationship);
      }
      continue;
    }

    result.add(mf.relationship);
  }

  return result;
};
